import {useMutation} from "@tanstack/react-query";

import {editMaterialNoteMutationOptions} from "./edit-material-note.mutation-options";

export function useEditMaterialNote(id: string, noteId: number) {
  return useMutation(editMaterialNoteMutationOptions(id, noteId));
}
